import { Routes } from '@angular/router';
import { adminGuard } from '../../guards/admin-guard';
import { canActivateAuthRole } from '../../guards/auth-guard';
import { ADMIN_ROLES } from './admin-roles.config';

export const adminRoutes: Routes = [
  {
    path: 'admin',
    loadComponent: () =>
      import('../../core/layouts/admin-layout/admin-layout.component').then(
        (m) => m.AdminLayoutComponent,
      ),
    canActivate: [adminGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./admin-home/admin-home.component').then(
            (m) => m.AdminHomeComponent,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./admin-settings/admin-settings.component').then(
            (m) => m.AdminSettingsComponent,
          ),
      },
      {
        path: 'stranke',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./admin-stranke/admin-stranke-list.component').then(
                (m) => m.AdminStrankeListComponent,
              ),
          },
          {
            path: 'new',
            loadComponent: () =>
              import('./admin-stranke/admin-stranke-form.component').then(
                (m) => m.AdminStrankeFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./admin-stranke/admin-stranke-form.component').then(
                (m) => m.AdminStrankeFormComponent,
              ),
          },
        ],
      },
      {
        path: 'punomocnici',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./admin-punomocnici/admin-punomocnici-list.component').then(
                (m) => m.AdminPunomocniciListComponent,
              ),
          },
          {
            path: 'new',
            loadComponent: () =>
              import('./admin-punomocnici/admin-punomocnici-form.component').then(
                (m) => m.AdminPunomocniciFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./admin-punomocnici/admin-punomocnici-form.component').then(
                (m) => m.AdminPunomocniciFormComponent,
              ),
          },
        ],
      },
      {
        path: 'predmeti-za-aktivaciju',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./admin-predmeti-za-aktivaciju/admin-predmeti-za-aktivaciju-list.component').then(
                (m) => m.AdminPredmetiZaAktivacijuListComponent,
              ),
          },
          {
            path: 'import',
            loadComponent: () =>
              import('./admin-predmeti-za-aktivaciju/admin-predmeti-za-aktivaciju-import.component').then(
                (m) => m.AdminPredmetiZaAktivacijuImportComponent,
              ),
          },
          {
            path: 'import-history',
            loadComponent: () =>
              import('./admin-predmeti-za-aktivaciju/admin-predmeti-za-aktivaciju-import-history.component').then(
                (m) => m.AdminPredmetiZaAktivacijuImportHistoryComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./admin-predmeti-za-aktivaciju/admin-predmeti-za-aktivaciju-form.component').then(
                (m) => m.AdminPredmetiZaAktivacijuFormComponent,
              ),
          },
        ],
      },
      {
        path: 'leko-predmeti',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./admin-leko-predmeti/admin-leko-predmeti-list.component').then(
                (m) => m.AdminLekoPredmetiListComponent,
              ),
          },
          {
            path: 'new',
            loadComponent: () =>
              import('./admin-leko-predmeti/admin-leko-predmeti-form.component').then(
                (m) => m.AdminLekoPredmetiFormComponent,
              ),
          },
          {
            path: 'import',
            loadComponent: () =>
              import('./admin-leko-predmeti/admin-leko-predmeti-import.component').then(
                (m) => m.AdminLekoPredmetiImportComponent,
              ),
          },
          {
            path: 'import-history',
            loadComponent: () =>
              import('./admin-leko-predmeti/admin-leko-predmeti-import-history.component').then(
                (m) => m.AdminLekoPredmetiImportHistoryComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./admin-leko-predmeti/admin-leko-predmeti-form.component').then(
                (m) => m.AdminLekoPredmetiFormComponent,
              ),
          },
        ],
      },
      {
        path: 'predlosci',
        canActivate: [canActivateAuthRole],
        data: { role: ADMIN_ROLES.TEMPLATE_ADMIN },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./admin-predlosci/admin-predlosci-list.component').then(
                (m) => m.AdminPredlosciListComponent,
              ),
          },
          {
            path: 'new',
            loadComponent: () =>
              import('./admin-predlosci/admin-predlosci-form.component').then(
                (m) => m.AdminPredlosciFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./admin-predlosci/admin-predlosci-form.component').then(
                (m) => m.AdminPredlosciFormComponent,
              ),
          },
        ],
      },
      {
        path: 'troskovi',
        canActivate: [canActivateAuthRole],
        data: { role: ADMIN_ROLES.SLANJE_TROSKOVA_ADMIN },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./admin-troskovi/admin-troskovi-list.component').then(
                (m) => m.AdminTroskoviListComponent,
              ),
          },
          {
            path: 'new',
            loadComponent: () =>
              import('./admin-troskovi/admin-troskovi-form.component').then(
                (m) => m.AdminTroskoviFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./admin-troskovi/admin-troskovi-form.component').then(
                (m) => m.AdminTroskoviFormComponent,
              ),
          },
        ],
      },
    ],
  },
];
